import AobInvoice from 'types/aobInvoice'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface SnlInvoiceStore {
  snlInvoiceHash: string | null;
  snlInvoice: AobInvoice | null;
  removedItems: number[];
  setRemovedItems: ( _removedItems: number[] ) => void;
  setSnlInvoice: ( snlInvoice: AobInvoice ) => void;
  setSnlInvoiceHash: ( snlInvoiceHash: string | null ) => void;
  editedInvoice: AobInvoice | null;
  setEditedInvoice: ( _editedInvoice: AobInvoice | null ) => void;
  snlPaymentCompleted: boolean;
  orderPlaced: boolean;
  setOrderPlaced: ( orderPlaced: boolean ) => void;
  setSnlPaymentCompleted: ( snlCompleted: boolean ) => void;
  clearSnlInvoice: () => void;
  error: boolean;
  setError: ( error: boolean ) => void;
}

export const useSnlInvoiceStore = create<SnlInvoiceStore>()(
  persist(
    ( set ): SnlInvoiceStore => ({
      snlInvoice: null,
      snlInvoiceHash: null,
      snlPaymentCompleted: false,
      orderPlaced: false,
      editedInvoice: null,
      removedItems: [],
      setEditedInvoice: ( editedInvoice ) => set({
        editedInvoice
      }),
      setRemovedItems: ( removedItems: number[] ) => set({
        removedItems
      }),
      setOrderPlaced: ( orderPlaced: boolean ) => set({
        orderPlaced
      }),
      setSnlInvoiceHash: ( snlInvoiceHash: string | null ) => set({
        snlInvoiceHash
      }),
      setSnlPaymentCompleted: ( snlPaymentCompleted: boolean ) => set({
        snlPaymentCompleted
      }),
      error: false,
      setError: ( error: boolean ) => set({
        error
      }),
      setSnlInvoice: ( snlInvoice: AobInvoice ) => set({
        snlInvoice
      }),
      clearSnlInvoice: () => set({
        snlInvoice: null,
        snlPaymentCompleted: false,
        snlInvoiceHash: null,
        error: false,
        removedItems: [],
        editedInvoice: null
      })
    }),
    {
      storage: createJSONStorage( () => sessionStorage ),
      name: `snl-invoice`
    }
  )
)